import { tablet, mobile } from "../../../mediaQueries";

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    minWidth: "205px",
    transition: "all 0.2s",
    backgroundColor: "rgba(197, 190, 181, 0.12)",
    padding: "12px",
    color: "#575452",
    margin: "5px 0",
    cursor: "none !important",
    "&:hover": {
      backgroundColor: "rgba(197, 190, 181, 0.2)",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      minWidth: "160px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      flexDirection: "column",
      minHeight: "auto",
      minWidth: "112px",
      padding: "16px",
      margin: "0 .5rem",
    },
  },
  img: {
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    filter: "drop-shadow(2px 4px 8px rgba(0, 0, 0, 0.1))",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      height: "50px",
      width: "50px",
    },
  },
  text: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    fontSize: "14px",
    color: "inherit",
    textTransform: "uppercase",
    margin: 0,
    marginLeft: "10px",
    letterSpacing: "0.05em",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      fontSize: "1rem",
    },
  },
  active: {
    cursor: "none !important",
    backgroundColor: "#989994 !important",
    color: "white !important",
  },
});

export default styles;
